import React from 'react';
import classNames from 'classnames';

import { ProgressBar } from 'primereact/progressbar';
import {calcPercent} from '../utils/utils'

const ProgressoSecoes = (props) => {    
    
    let percentual = calcPercent(props.lidas, props.total)   

    const wrapperbarraprogresso = classNames("barraProgresso",{
        "barraAnimada": (percentual!=0 && percentual<100),
        "barraVazia": percentual==0,
        "barraCheia": percentual>=100
    })    

    return (
        <div className="bloco-dados bloco-large">
      
            <div className="bloco-progesso-title">
                <div className="bloco-title">
                    {props.titulo || "Seções Lidas"}: 
                </div>
                <div className="bloco-subtitle">
                    {props?.total!=undefined && props?.lidas!=undefined && <b>{props.lidas.toLocaleString()}{"/"}{props.total.toLocaleString()}</b>}
                </div>
            </div>

            <ProgressBar className={wrapperbarraprogresso} 
                value={percentual}
                displayValueTemplate={(value) => <React.Fragment></React.Fragment>}/>            
            
            <div className="ultima-atualizacao-data">                 
                {props?.data && <div>Atualizado em: {props?.data}</div>}
            </div>

        </div>
    )
}

export default ProgressoSecoes;    
